// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 484) return "484.css";
	if (chunkId === 789) return "789.css";
	// return url for filenames based on template
	return "" + (chunkId === 179 ? "main" : chunkId) + ".css";
};